import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PrintService {
    public printElement(windowTitle: string, elementId: string, excludeClass: string = 'd-print-none') {
        const element = document.getElementById(elementId);
        const clonedElement = element.cloneNode(true) as HTMLElement;
        this.removeElementsByClass(clonedElement, excludeClass);

        this.openPrintWindow(windowTitle, clonedElement.innerHTML);
    }

    /**
     * Prints rows as a plain table. A kit table draws inside its shadow root, which
     * printElement's innerHTML copy cannot see, so a kit screen hands over its rows instead.
     */
    public printTable(windowTitle: string, headers: string[], rows: string[][]): void {
        const head = headers.map((header) => '<th>' + this.escapeHtml(header) + '</th>').join('');
        const body = rows
                .map((row) => '<tr>' + row.map((cell) => '<td>' + this.escapeHtml(cell) + '</td>').join('') + '</tr>')
                .join('');

        this.openPrintWindow(windowTitle, '<table class="table"><thead><tr>' + head + '</tr></thead><tbody>' + body + '</tbody></table>');
    }

    private openPrintWindow(windowTitle: string, printContents: string): void {
        const stylesHtml = this.getTagsHtml('style');
        const linksHtml = this.getTagsHtml('link').replace('href="styles.css"', 'href="' + window.origin + '/styles.css"');

        const popupWin = window.open('', '_blank', 'top=0,left=0,height=600,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
            <html>
                <head>
                    <title>${windowTitle}</title>
                    ${linksHtml}
                    ${stylesHtml}
                </head>
                <body onload="window.print(); window.close()">
                    ${printContents}
                </body>
            </html>
        `);
        popupWin.document.close();
    }

    private escapeHtml(value: string): string {
        return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
    }

    private removeElementsByClass(element: HTMLElement, className: string): void {
        const elements = element.getElementsByClassName(className);
        const elementsArray = Array.from(elements);
        elementsArray.forEach(el => el.parentNode?.removeChild(el));
    }

    private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
        const htmlStr: string[] = [];
        const elements = document.getElementsByTagName(tagName);
        for (let idx = 0; idx < elements.length; idx++) {
            htmlStr.push(elements[idx].outerHTML);
        }
        return htmlStr.join('\r\n');
    }
}
